import React from "react";

// Popular cities list (matching the allowed cities from the pricing page)
const POPULAR_CITIES = [
  { slug: "delhi-ncr", name: "Delhi" },
  { slug: "mumbai", name: "Mumbai" },
  { slug: "bangalore", name: "Bangalore" },
  { slug: "chennai", name: "Chennai" },
  { slug: "hyderabad", name: "Hyderabad" },
  { slug: "pune", name: "Pune" },
  { slug: "kolkata", name: "Kolkata" },
  { slug: "jaipur", name: "Jaipur" },
  { slug: "lucknow", name: "Lucknow" },
  { slug: "ahmedabad", name: "Ahmedabad" },
  { slug: "indore", name: "Indore" },
];

const PricingPopularCities = ({ vehicleBrand = "", vehicleName = "", brand = "", model = "" }) => {
  // Use vehicleBrand and vehicleName if provided, otherwise use brand and model
  const displayBrand = vehicleBrand || brand;
  const displayName = vehicleName || model;

  // Generate the heading text
  const heading = displayBrand && displayName 
    ? `${displayBrand} ${displayName} Price in Popular Cities`
    : "Price in Popular Cities";

  return (
    <div className="w-full md:w-[84%] mx-auto px-3 md:px-0 py-8 md:py-12 bg-white">
      <div className="w-full">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8">
          {heading}
        </h2>
        <div className="flex flex-wrap gap-3 md:gap-4">
          {POPULAR_CITIES.map((city) => {
            const href = `/electric-commercial-vehicles/${brand}/${model}/price/${city.slug}`;
            return (
              <a
                key={city.slug}
                href={href}
                className="px-4 md:px-6 py-2 md:py-2.5 bg-white border border-gray-200 rounded-full text-sm md:text-base text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-colors duration-200"
              >
                {city.name}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PricingPopularCities;
